import React, { useState } from 'react';
import { Alert, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import AppDialog, { AppDialogHeader } from '../common/AppDialog';
import { ReceiptLongOutlined } from '@mui/icons-material';
import { CreateExpenseRequest, Expense, UpdateExpenseRequest } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';
import { useExpenseMutations } from '../../hooks/useExpenseMutations';
import { errorMessage } from '../../utils/errorMessage';
import ExpenseForm from './ExpenseForm';

interface ExpenseDialogProps { open: boolean; expense?: Expense; onClose: () => void; onSuccess: () => void; }

const ExpenseDialog: React.FC<ExpenseDialogProps> = ({ open, expense, onClose, onSuccess }) => {
  const { t } = useLanguage();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [error, setError] = useState<string | null>(null);
  const { saveExpenseMutation } = useExpenseMutations();
  const editing = !!expense;
  const submit = async (data: CreateExpenseRequest | UpdateExpenseRequest) => {
    try {
      setError(null);
      await saveExpenseMutation.mutateAsync({ id: expense?.id, data });
      onSuccess();
      onClose();
    } catch (cause) {
      setError(errorMessage(cause, editing ? t('expenses.updateError') : t('expenses.createError')));
    }
  };
  return (
    <AppDialog presentation="form" footerInside open={open} onClose={saveExpenseMutation.isPending ? undefined : onClose} fullWidth maxWidth="sm" fullScreen={mobile} PaperProps={{ sx: { borderRadius: mobile ? 0 : 2, overflow: 'hidden' } }}>
      <AppDialogHeader icon={<ReceiptLongOutlined />} subtitle={expense?.description}>
        {editing ? t('expenses.editExpense') : t('expenses.createExpense')}
      </AppDialogHeader>
      <DialogContent>{error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}<ExpenseForm expense={expense} onSubmit={submit} onCancel={onClose} isLoading={saveExpenseMutation.isPending} /></DialogContent>
    </AppDialog>
  );
};
export default ExpenseDialog;
